export default {
  code: {
    appStoreDown: "蘋果版本下載",
    googlePlayDown: "谷歌版本下載",
    androidDown: "安卓版本下載",
    huaweiDown: "華為版本下載",
    stratumMessage: "點擊右上角選擇瀏覽器打開",
    iKnow: "知道了",
    update: "更新",
    cancel: "取消",
    noData: "暫無數據",
    installationNotice: "安裝提示",
    huaweiDownTips: {
      after: "🔐🔐 如果安裝受阻？關閉純淨模式：",
      before: "設置 → 系統和更新 → 純淨模式 → 退出"
    },
    xiaomiDownTips: {
      after: "🔐🔐 如果安裝受阻？點擊單次授權：",
      before: "右上角「更多」圖標 → 授權單次安裝"
    }
  }
};
